import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { cn } from "@/lib/utils";

interface IntlPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  defaultCountry?: any;
  placeholder?: string;
  disabled?: boolean;
  hasError?: boolean;
  id?: string;
}

/**
 * International phone input with country selector + flag.
 * Stores value in E.164 format (e.g. "+34600123456").
 */
export const IntlPhoneInput = ({
  value,
  onChange,
  defaultCountry = "US",
  placeholder = "Phone number",
  disabled,
  hasError,
  id,
}: IntlPhoneInputProps) => {
  return (
    <PhoneInput
      id={id}
      international
      countryCallingCodeEditable={false}
      defaultCountry={defaultCountry}
      value={value}
      onChange={(v) => onChange(v ?? "")}
      placeholder={placeholder}
      disabled={disabled}
      className={cn("intl-phone-input", hasError && "intl-phone-input--error")}
    />
  );
};